module.exports = __webpack_public_path__ + "static/media/slide-4.e217fb53.jpg";